export default __webpack_public_path__ + "static/media/IBimagePelvicobliquity2.44c16fad.png";